export const Globals = {
    get token() {
        return localStorage.getItem("token");
    }
};